module.exports = "<div class=\"container-fluid padXS1\" #galeriaSection style=\"margin-top: 3.6rem;\">\r\n\t<div class=\"container padXS1\">\r\n\t\t<ngx-gallery [options]=\"galeriaOpciones\" [images]=\"galeriaImagenes\"></ngx-gallery>\r\n\t</div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Front-end/[PROYECTO] abordo-empresarial-cli4/[RAMA] actualizarAngular-Analytics/abordo-empresarial-cli4/src/app/componentes/galeria/galeria.component.html
// module id = ../../../../../src/app/componentes/galeria/galeria.component.html
// module chunks = 1